import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Label = styled.span`
  background-color: #f44336;
  bottom: 0;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  height: 20px;
  left: 0;
  line-height: 20px;
  padding: 0 4px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;

  &::before {
    content: '● '
  }

  &.small {
    font-size: 8px;
    height: 15px;
    line-height: 15px;
  }

  &.big {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
  }

  &.inline {
    display: inline-block;
    font-size: 10px;
    height: 18px;
    line-height: 18px;
    margin-left: 10px;
    margin-right: 0;
    position: unset;
    vertical-align: top;
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      position: relative;
      float: right;
    };
  }
`

/**
 * Featured Article Label Component
 */
class FeaturedLabel extends Component {
  /**
   * @returns {XML}
   */
  render () {
    const {
      featuredClass,
      title,
      ...props
    } = this.props

    return (
      <Label className={featuredClass} {...props}>
        { title }
      </Label>
    )
  }
}

FeaturedLabel.defaultProps = {
  featuredClass: '',
  title: ''
}

FeaturedLabel.propTypes = {
  featuredClass: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default FeaturedLabel
